/**
 * Diacritic- and case-insensitive normalization for client-side text search.
 * Teachers type fast without dấu — "thien an" still has to match "Thiên Ân",
 * "khanh" still has to match "Khánh" — so both the query and the candidate
 * text get folded down to plain ASCII-ish lowercase before comparing.
 *
 * NFD splits base letters from their combining accent marks so the marks can
 * be stripped; it does NOT touch đ/Đ, which is its own letter rather than a
 * base letter plus a mark, so that gets an explicit fold — same two-step the
 * repo's slug generators (apps/api/src/lib/slug.ts,
 * packages/shared-types/src/blog.ts) use. Not reusing those directly: they
 * additionally hyphenate and truncate for URLs, which would corrupt
 * substring matching (spaces become "-", not removed).
 */
export function normalizeForSearch(text: string): string {
  return text
    .toLowerCase()
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .replace(/đ/g, 'd');
}
